import React, { useEffect, useState } from 'react'
import Post from './Post'
import { db } from "../../firebase"
import CommonHeader from '../../sub-components/CommonHeader';
import Footer from '../../sub-components/Footer';
import SliderHeader from '../../sub-components/SliderHeader';
import MenuCategory from '../../sub-components/MenuCategory';
import ReactPaginate from "react-paginate";
import Pagination from '@mui/material/Pagination';
import HomeCategories from '../../sub-components/HomeCategories';
import Slider1 from '../../sub-components/MenuCategory/Slider1';

function Menus() {
  const [posts, setPosts] = useState([])
  const [pageNumber, setPageNumber] = useState(0);
  const [input, setInput] = useState("");
  const [posts1, setPosts1] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);

  
  useEffect(() => {
    db.collection('menus').onSnapshot((snapshot) => {
      setPosts1(snapshot.docs.map((doc) => doc.data()))
    })

    if (posts1 !== undefined) {
      const finalPosts = posts1.filter(res => {
        return res.menuName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
        // console.log("sth is in: ",res.menuName.toLowerCase())
      })

      setFilteredPosts(finalPosts)
    }else {
      return <div>No results3</div>
    }
  }, [searchTerm])

  const updateSearchResults = (e) => {
    setSearchTerm(e.target.value)
    // document.getElementsByClassName('dropdown-content3')[0].style.display = 'auto';
  }

  const totalRatings = (posts.reduce((a,v) =>  a = a + v.post.rating , 0 ))
  const numberOfRatings = posts.length
  const rating = totalRatings / numberOfRatings
  var a = Math.round(rating * 10) / 10

   useEffect(() => {
       db.collection('menus').onSnapshot(snapshot => {
           setPosts(snapshot.docs.map(doc => ({
               id: doc.id,
               post: doc.data(),
           })));
       })
   }, []);
   const menusPerPage = 12;
   const pagesVisited = pageNumber * menusPerPage;

   const displayMenus = <div>
   <CommonHeader/>
   <section
    style={{  
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)) , url(" + "https://i0.wp.com/digital-photography-school.com/wp-content/uploads/2018/01/Charcuterie_Darina-Kopcok.jpg?ssl=1" + ")",
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    }}
      className=" mt-20 bg-dark text-center">
      <h1 style={{marginTop:30}} className="text-white">Menus</h1>
      <h6 className="text-white-50">Best deals at your favourite restaurants</h6>
    </section>
        {/* <div><MenuCategory /></div> */}
       <section className="section pt-5 pb-5 products-listing">
         <div className="container">
           <div className="row d-none-m">
             <div className="col-md-12">
               <h4 className="font-weight-bold mt-0 mb-3">MENUs Categories<small className="h6 mb-0 ml-2">
                 </small>
               </h4>
             </div>
           </div>
           <div>
         {/* SideBar here */}
             <div className="">
             <Slider1 />
             <hr />
                           <div className="row d-none-m">
             <div className="col-md-12">
               <div className="dropdown float-right">
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">All</span> &nbsp;&nbsp;
                 </a>
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">Newest</span> &nbsp;&nbsp;
                 </a>
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">Ratings</span> &nbsp;&nbsp;
                 </a>
               </div>
               <h4 className="font-weight-bold mt-0 mb-3">AVAILABLE MENUs<small className="h6 mb-0 ml-2">
                 </small>
               </h4>
             </div>
           </div>
           <hr />
           <form className="explore-outlets-search mb-4 rounded overflow-hidden border">
       <div className="input-group">
         <input type="text" onChange={updateSearchResults} placeholder="Search for menus..." className="form-control border-0" />
         <div className="input-group-append">
           <button type="button" className="btn btn-primary">
             <i className="icofont-search" />
           </button>
         </div>
       </div>
     </form>
             <div className="product-list-view">
   
           <div className="row">
             {searchTerm === "" ?(
                  <>
                             {
             // hakuna > || iko < 
             posts.length > 0 ?(
               <>
               {
                              posts.slice(pagesVisited, pagesVisited + menusPerPage).map(({id, post}) => (
                                 <Post
                                 key={id} 
                                 mealImage={post.mealImage}
                                 branchId={post.branchId}
                                 createdById={post.createdBy}
                                 mealArrayIds={post.mealArrayIds}
                                 menuName={post.menuName}
                                 menuCategories={post.menuCategories}
                                 rating={post?.rating}
                                 restId={post.restId}
                                 timestamp={post.timestamp}
                                 menuAvailability={post?.menuAvailability}
                                 menuId={id}
                                 numberOfRatings={post?.numberOfRatings}
                                 totalRates={a}
                                 restaurant={post?.restaurant}
                                 />
                               ))
               }
               </>
             ) : (<>  <center><i style={{fontSize:18,fontWeight:'bold'}}>Loading...</i></center>
             </>)  
   } 
                  </>
             ):(
               <>
                            <div className="product-list-view">
   <div className="row">
            {
              filteredPosts.length > 0 ?(
                <>
                {
                                filteredPosts.map((posts2) => (

<Post 
mealImage={posts2.mealImage}
branchId={posts2.branchId}
createdById={posts2.createdBy}
mealArrayIds={posts2.mealArrayIds}
menuName={posts2.menuName}
menuCategories={posts2.menuCategories}
rating={posts2?.rating}
restId={posts2.restId}
timestamp={posts2.timestamp}
menuAvailability={posts2?.menuAvailability}
menuId={posts2?.menuId}
numberOfRatings={posts2?.numberOfRatings}
totalRates={a}
restaurant={posts2?.restaurant}
/>
    ))
                                }
                </>
              ):(
                <><center style={{fontWeight:'bold'}}><h4>No results...</h4></center></>
              )

              
            
            }
          </div>
          </div>
               </>
             )}

     </div>
     </div>
   
              
   
             </div>
           </div>
         </div>
       </section>
   
   
   
   
   </div>

 const pageCount = Math.ceil(posts.length / menusPerPage);
 const changePage = ({ selected }) => {
   setPageNumber(selected);
 };


  return (
   <div>
     {displayMenus}
     <center>
       
     <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        pageCount={pageCount}
        pageCountClassName={"pagecount"}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
     </center>

         <Footer />
   </div>
  )
}

export default Menus




